import React, {ReactNode, useState} from 'react';
import { IconDelete } from '@nxsys/components/AppIconSvg';
import AppConfirmationDeleteModal from '../AppConfirmationDeleteModal';
import AppIconButton from '../AppIconButton';

type AppsDeleteIconProps = {
  deleteAction: () => void;
  title: string | ReactNode;
  paragraph?: string | ReactNode;
  icon?: ReactNode;
  iconInfo?: string;
};
const AppsDeleteIcon: React.FC<AppsDeleteIconProps> = ({
  title,
  paragraph,
  deleteAction,
  iconInfo = 'Delete',
  ...rest
}) => {
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const onDeny = () => {
    setDeleteModalOpen(!isDeleteModalOpen);
  };
  const onConfirm = () => {
    deleteAction();
    setDeleteModalOpen(false);
  };
  return (
    <>
      <AppIconButton
        title={iconInfo}
        icon={<IconDelete />}
        onClick={onDeny}
        {...rest}
      />
      {isDeleteModalOpen ? (
        <AppConfirmationDeleteModal
          open={isDeleteModalOpen}
          paragraph={paragraph || "Are you sure you want to delete this?"}
          onDeny={onDeny}
          onConfirm={onConfirm}
          title={title}
        />
      ) : null}
    </>
  );
};

export default AppsDeleteIcon;
